"use client";
import React from "react";
import * as _Builtin from "./_Builtin";
import * as _interactions from "./interactions";
import * as _utils from "./utils";
import _styles from "./SponsoredListingReview.module.css";

const _interactionsData = JSON.parse(
  '{"events":{"e-335":{"id":"e-335","name":"","animationType":"preset","eventTypeId":"SCROLL_INTO_VIEW","action":{"id":"","actionTypeId":"SLIDE_EFFECT","instant":false,"config":{"actionListId":"slideInBottom","autoStopEventId":"e-336"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"b9440a34-756f-012e-8030-098561cd23ff","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"b9440a34-756f-012e-8030-098561cd23ff","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":0,"scrollOffsetUnit":"%","delay":150,"direction":"BOTTOM","effectIn":true},"createdOn":1682571573981},"e-337":{"id":"e-337","name":"","animationType":"preset","eventTypeId":"SCROLL_INTO_VIEW","action":{"id":"","actionTypeId":"SLIDE_EFFECT","instant":false,"config":{"actionListId":"slideInBottom","autoStopEventId":"e-338"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"b9440a34-756f-012e-8030-098561cd2402","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"b9440a34-756f-012e-8030-098561cd2402","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":0,"scrollOffsetUnit":"%","delay":300,"direction":"BOTTOM","effectIn":true},"createdOn":1682571587787},"e-339":{"id":"e-339","name":"","animationType":"preset","eventTypeId":"SCROLL_INTO_VIEW","action":{"id":"","actionTypeId":"SLIDE_EFFECT","instant":false,"config":{"actionListId":"slideInBottom","autoStopEventId":"e-340"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"b9440a34-756f-012e-8030-098561cd2406","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"b9440a34-756f-012e-8030-098561cd2406","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":0,"scrollOffsetUnit":"%","delay":200,"direction":"BOTTOM","effectIn":true},"createdOn":1694037821446},"e-341":{"id":"e-341","name":"","animationType":"preset","eventTypeId":"SCROLL_INTO_VIEW","action":{"id":"","actionTypeId":"SLIDE_EFFECT","instant":false,"config":{"actionListId":"slideInLeft","autoStopEventId":"e-342"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"b9440a34-756f-012e-8030-098561cd2416","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"b9440a34-756f-012e-8030-098561cd2416","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":0,"scrollOffsetUnit":"%","delay":400,"direction":"LEFT","effectIn":true},"createdOn":1694037834180},"e-343":{"id":"e-343","name":"","animationType":"preset","eventTypeId":"SCROLL_INTO_VIEW","action":{"id":"","actionTypeId":"SLIDE_EFFECT","instant":false,"config":{"actionListId":"slideInLeft","autoStopEventId":"e-344"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"b9440a34-756f-012e-8030-098561cd2426","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"b9440a34-756f-012e-8030-098561cd2426","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":0,"scrollOffsetUnit":"%","delay":600,"direction":"LEFT","effectIn":true},"createdOn":1694037843779}},"actionLists":{"slideInBottom":{"id":"slideInBottom","useFirstGroupAsInitialState":true,"actionItemGroups":[{"actionItems":[{"actionTypeId":"STYLE_OPACITY","config":{"delay":0,"duration":0,"target":{"id":"N/A","appliesTo":"TRIGGER_ELEMENT","useEventTarget":true},"value":0}}]},{"actionItems":[{"actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"duration":0,"target":{"id":"N/A","appliesTo":"TRIGGER_ELEMENT","useEventTarget":true},"xValue":0,"yValue":100,"xUnit":"PX","yUnit":"PX","zUnit":"PX"}}]},{"actionItems":[{"actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"outQuart","duration":1000,"target":{"id":"N/A","appliesTo":"TRIGGER_ELEMENT","useEventTarget":true},"xValue":0,"yValue":0,"xUnit":"PX","yUnit":"PX","zUnit":"PX"}},{"actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"outQuart","duration":1000,"target":{"id":"N/A","appliesTo":"TRIGGER_ELEMENT","useEventTarget":true},"value":1}}]}]},"slideInLeft":{"id":"slideInLeft","useFirstGroupAsInitialState":true,"actionItemGroups":[{"actionItems":[{"actionTypeId":"STYLE_OPACITY","config":{"delay":0,"duration":0,"target":{"id":"N/A","appliesTo":"TRIGGER_ELEMENT","useEventTarget":true},"value":0}}]},{"actionItems":[{"actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"duration":0,"target":{"id":"N/A","appliesTo":"TRIGGER_ELEMENT","useEventTarget":true},"xValue":-100,"yValue":0,"xUnit":"PX","yUnit":"PX","zUnit":"PX"}}]},{"actionItems":[{"actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"outQuart","duration":1000,"target":{"id":"N/A","appliesTo":"TRIGGER_ELEMENT","useEventTarget":true},"value":1}},{"actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"outQuart","duration":1000,"target":{"id":"N/A","appliesTo":"TRIGGER_ELEMENT","useEventTarget":true},"xValue":0,"yValue":0,"xUnit":"PX","yUnit":"PX","zUnit":"PX"}}]}]}},"site":{"mediaQueries":[{"key":"main","min":992,"max":10000},{"key":"medium","min":768,"max":991},{"key":"small","min":480,"max":767},{"key":"tiny","min":0,"max":479}]}}'
);

export function SponsoredListingReview({ as: _Component = _Builtin.Section }) {
  _interactions.useInteractions(_interactionsData, _styles);

  return (
    <_Component
      className={_utils.cx(_styles, "home-page-review-section")}
      grid={{
        type: "section",
      }}
      tag="section"
      id="SponsoredListingReview"
    >
      <_Builtin.Container
        className={_utils.cx(_styles, "home-page-review-container")}
        tag="div"
      >
        <_Builtin.Block
          className={_utils.cx(_styles, "about-page-review-main-block")}
          tag="div"
        >
          <_Builtin.Block
            className={_utils.cx(_styles, "overflow-off")}
            tag="div"
          >
            <_Builtin.Heading
              className={_utils.cx(_styles, "about-page-review-heading")}
              data-w-id="b9440a34-756f-012e-8030-098561cd23ff"
              tag="h2"
            >
              {"We're changing the way Canada rents"}
            </_Builtin.Heading>
          </_Builtin.Block>
          <_Builtin.Block
            className={_utils.cx(_styles, "overflow-off")}
            tag="div"
          >
            <_Builtin.Paragraph
              className={_utils.cx(_styles, "about-page-review-para")}
              data-w-id="b9440a34-756f-012e-8030-098561cd2402"
            >
              {
                "See why thousands of landlords and property managers love our rental management features."
              }
            </_Builtin.Paragraph>
          </_Builtin.Block>
          <_Builtin.Block
            className={_utils.cx(_styles, "review-block")}
            tag="div"
          >
            <_Builtin.Block
              className={_utils.cx(_styles, "home-page-reviews")}
              tag="div"
            >
              <_Builtin.Block
                className={_utils.cx(_styles, "review")}
                id={_utils.cx(
                  _styles,
                  "w-node-b9440a34-756f-012e-8030-098561cd2406-61cd23fb"
                )}
                data-w-id="b9440a34-756f-012e-8030-098561cd2406"
                tag="div"
              >
                <_Builtin.Block
                  className={_utils.cx(_styles, "home-page-quotes-block")}
                  tag="div"
                >
                  <_Builtin.Image
                    className={_utils.cx(_styles, "quotes-icon")}
                    loading="lazy"
                    width="32"
                    height="32"
                    alt=""
                    src="https://uploads-ssl.webflow.com/64d3f7fe1cc4f17b36a7a5ef/64f8f5b59e4a1ae76f29e4c2_quotes.png"
                  />
                </_Builtin.Block>
                <_Builtin.Block
                  className={_utils.cx(_styles, "paragraph-block")}
                  tag="div"
                >
                  <_Builtin.Paragraph
                    className={_utils.cx(_styles, "review-text")}
                  >
                    {"As a property manager, "}
                    <_Builtin.Strong>
                      {
                        "I like how easy it is for tenants to apply for a rental"
                      }
                    </_Builtin.Strong>
                    {
                      ", and for us to review all the pertinent information in one place."
                    }
                  </_Builtin.Paragraph>
                </_Builtin.Block>
                <_Builtin.Block
                  className={_utils.cx(_styles, "people-name-and-image")}
                  tag="div"
                >
                  <_Builtin.Block
                    className={_utils.cx(_styles, "name-block")}
                    tag="div"
                  >
                    <_Builtin.Block
                      className={_utils.cx(
                        _styles,
                        "header-small",
                        "heading-small"
                      )}
                      tag="div"
                    >
                      {"Klaus R."}
                    </_Builtin.Block>
                    <_Builtin.Paragraph
                      className={_utils.cx(_styles, "job-role")}
                    >
                      {"Century 21 In Town Realty"}
                    </_Builtin.Paragraph>
                  </_Builtin.Block>
                  <_Builtin.Block
                    className={_utils.cx(_styles, "profile-image-block-one")}
                    tag="div"
                  />
                </_Builtin.Block>
              </_Builtin.Block>
              <_Builtin.Block
                className={_utils.cx(_styles, "review")}
                id={_utils.cx(
                  _styles,
                  "w-node-b9440a34-756f-012e-8030-098561cd2416-61cd23fb"
                )}
                data-w-id="b9440a34-756f-012e-8030-098561cd2416"
                tag="div"
              >
                <_Builtin.Block
                  className={_utils.cx(_styles, "home-page-quotes-block")}
                  tag="div"
                >
                  <_Builtin.Image
                    className={_utils.cx(_styles, "quotes-icon")}
                    loading="lazy"
                    width="32"
                    height="32"
                    alt=""
                    src="https://uploads-ssl.webflow.com/64d3f7fe1cc4f17b36a7a5ef/64f8f5b59e4a1ae76f29e4c2_quotes.png"
                  />
                </_Builtin.Block>
                <_Builtin.Block
                  className={_utils.cx(_styles, "paragraph-block")}
                  tag="div"
                >
                  <_Builtin.Paragraph
                    className={_utils.cx(_styles, "review-text")}
                  >
                    {"liv.rent has helped me with "}
                    <_Builtin.Strong>
                      {"matching the prospect tenants meeting my requirements"}
                    </_Builtin.Strong>
                    {
                      ". The whole process from advertisement to signing a contract is fully integrated and easy to use."
                    }
                  </_Builtin.Paragraph>
                </_Builtin.Block>
                <_Builtin.Block
                  className={_utils.cx(_styles, "people-name-and-image")}
                  tag="div"
                >
                  <_Builtin.Block
                    className={_utils.cx(_styles, "name-block")}
                    tag="div"
                  >
                    <_Builtin.Block
                      className={_utils.cx(
                        _styles,
                        "header-small",
                        "heading-small"
                      )}
                      tag="div"
                    >
                      {"John S."}
                    </_Builtin.Block>
                    <_Builtin.Paragraph
                      className={_utils.cx(_styles, "job-role")}
                    >
                      {"Verified Landlord"}
                    </_Builtin.Paragraph>
                  </_Builtin.Block>
                  <_Builtin.Block
                    className={_utils.cx(_styles, "profile-image-block-one")}
                    tag="div"
                  />
                </_Builtin.Block>
              </_Builtin.Block>
              <_Builtin.Block
                className={_utils.cx(_styles, "review")}
                id={_utils.cx(
                  _styles,
                  "w-node-b9440a34-756f-012e-8030-098561cd2426-61cd23fb"
                )}
                data-w-id="b9440a34-756f-012e-8030-098561cd2426"
                tag="div"
              >
                <_Builtin.Block
                  className={_utils.cx(_styles, "home-page-quotes-block")}
                  tag="div"
                >
                  <_Builtin.Image
                    className={_utils.cx(_styles, "quotes-icon")}
                    loading="lazy"
                    width="32"
                    height="32"
                    alt=""
                    src="https://uploads-ssl.webflow.com/64d3f7fe1cc4f17b36a7a5ef/64f8f5b59e4a1ae76f29e4c2_quotes.png"
                  />
                </_Builtin.Block>
                <_Builtin.Block
                  className={_utils.cx(_styles, "paragraph-block")}
                  tag="div"
                >
                  <_Builtin.Paragraph
                    className={_utils.cx(_styles, "review-text")}
                  >
                    <_Builtin.Strong>
                      {
                        "The selling point for us was the syndication of listings to facebook marketplace AND facebook groups."
                      }
                    </_Builtin.Strong>
                    {
                      " Also, they have taken alot of feedback from us for new features..."
                    }
                  </_Builtin.Paragraph>
                </_Builtin.Block>
                <_Builtin.Block
                  className={_utils.cx(_styles, "people-name-and-image")}
                  tag="div"
                >
                  <_Builtin.Block
                    className={_utils.cx(_styles, "name-block")}
                    tag="div"
                  >
                    <_Builtin.Block
                      className={_utils.cx(
                        _styles,
                        "header-small",
                        "heading-small"
                      )}
                      tag="div"
                    >
                      {"Jonathan C."}
                    </_Builtin.Block>
                    <_Builtin.Paragraph
                      className={_utils.cx(_styles, "job-role")}
                    >
                      <_Builtin.Link
                        button={false}
                        block=""
                        options={{
                          href: "https://liv.rent/company/gathercoliving",
                        }}
                      >
                        {"Gather Co-Living"}
                      </_Builtin.Link>
                    </_Builtin.Paragraph>
                  </_Builtin.Block>
                  <_Builtin.Block
                    className={_utils.cx(_styles, "profile-image-block-one")}
                    tag="div"
                  />
                </_Builtin.Block>
              </_Builtin.Block>
            </_Builtin.Block>
          </_Builtin.Block>
        </_Builtin.Block>
      </_Builtin.Container>
    </_Component>
  );
}
